export const WITHDRAWN_VALIDATION_AGE = 19
